module.exports = __webpack_public_path__ + "media/images/themes/default/logo-4633d095fa4cac81ca559deeab6f9878.svg";